<template>
  <div id="main-bandaid">
    <div id="bandaid">
      <a
        v-if="quantity > 0"
        href="#"
        class="bandaid-sign-neg"
        @click="lessQuantity"
        >-</a
      >
      <span class="bandaid-sign">{{ quantity }}</span>
      <a href="#" class="bandaid-sign-plus" @click="plusQuantity">+</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "BandAid",
  props: {
    quantity: {
      type: Number,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    plusQuantity(e) {
      e.preventDefault();
      this.$emit("plusQuantity");
    },
    lessQuantity(e) {
      e.preventDefault();
      this.$emit("lessQuantity");
    },
  },
};
</script>
<style scoped>
.bandaid-sign {
  line-height: normal;
  display: inline;
  font-size: 1.5em;
  margin-right: 1.5vw;
  margin-left: 1.5vw;
  text-decoration: none;
  color: #3498db !important;
}
.bandaid-sign-plus {
  line-height: normal;
  display: inline;
  font-size: 1.5em;
  text-decoration: none;
  color: #3498db !important;
}
.bandaid-sign-plus:hover {
  font-weight: 900;
}
.bandaid-sign-neg:hover {
  font-weight: 900;
}
.bandaid-sign-neg {
  line-height: normal;
  display: inline;
  font-size: 1.5em;
  text-decoration: none;
  color: #3498db !important;
}
#bandaid-amount {
  color: #3498db !important;
  font-weight: 600;
  display: inline;
}
#bandaid {
  /* vertical-align: middle; */
  border-radius: 25px;
  border: 1px solid #3498db !important;
  color: #3498db !important;
  width: 8em;
  text-align: center;
  /* margin: 0 auto; */
}
@media only screen and (max-width: 743px) {
  .bandaid-sign {
    margin-right: 2vw;
    margin-left: 2vw;
  }
  #bandaid {
    width: 5em;
    height: 1.5em;
  }
  .bandaid-sign {
    font-size: 1em;
  }
  .bandaid-sign-neg {
    font-size: 1em;
    font-weight: 900;
  }
  .bandaid-sign-plus {
    font-size: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BandAid.vue